<template>
  <EditableTableItem
    :blueish="true"
    :remove-icon="true"
    
    :value="value"
    @save="saveNewValue"
  >
    {{ `€ ${value}` }}
  </EditableTableItem>
</template>

<script>

import EditableTableItem from "./EditableTableItem.vue"
import fixDecimalCommaNotation from "../../mixins/fixDecimalCommaNotation"

export default {
  mixins: [
    fixDecimalCommaNotation(),
  ],
  components: {
    EditableTableItem,
  },
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
  },
  methods: {
    saveNewValue(val) {
      this.$emit("save", this.fixComma(val))
    },
  },
}

</script>
